<template>
<div class="fixed_page"  id="blurry">


  <div class="get-started">
    <div class="home-main">
      <div class="fixed_page">


        <div class="fixed_page">
          <div class="winners_upd_box" >
            <h1>{{ getTranslations.visitor_visitor_header_winners }}</h1>

            <img src="/static/images/winners_updated/WINNERS.png">
            <p>{{ getTranslations.visitor_visitor_winner_discover }} <span>{{ getTranslations.visitor_visitor_winner_lucky }}</span> {{ getTranslations.visitor_visitor_winner_far }}</p>

            <div class="winners__header__testimonials">
              <div class="testimonials__carousel">

              </div>
            </div>
          </div>
          <div class="winners_upd_grand" v-if="grandWin.length >0 ">
            <h1>{{ getTranslations.visitor_visitor_winner_grand }}</h1>
            <div v-for="(winner, index) in grandWin" :key="index">
              <div class="rank_row" >
                <img :src="winner.userDTO.avatar">
                <div class="upd_prize_col">
                  <h2>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }} {{ winner.userDTO.msisdn }}</h2>
                  <p>{{ winner.prizeDTO.headline }}</p>
                </div>
                <div class="vertical_line_rank"></div>
                <div class="rank_points">
                  <div class="rank_col">
                    <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                    <label>{{ normalizeDate(winner.localDateTime) }}</label>
                  </div>
                </div>
              </div>
              <div class="rank_border"></div>
            </div>

            <div class="load_more_btn rank" v-if="moreWinnersButton">
              <button  class="load-more btn2 btn2--std btn2--small" @click="displayMore('GRAND')" :disabled="loading.GRAND">···</button>
            </div>
            <div class="upd_prize_bottom">
              <p>{{ getTranslations.visitor_visitor_winner_the }} <span>{{ getTranslations.visitor_visitor_winner_next }}</span>{{ getTranslations.visitor_visitor_winner_announced }}<span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>
            </div>
            <div class="last_upt">
              <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
            </div>
          </div>
          <div v-else class="winners_upd_grand">
            <h1>{{ getTranslations.visitor_visitor_winner_grand }}</h1>
            <p>{{ getTranslations.visitor_visitor_winner_yet }}<span>{{ getTranslations.visitor_visitor_winner_next }}</span> {{ getTranslations.visitor_visitor_winner_announced }} <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>

            <div class="last_upt">
              <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
            </div>
          </div>

          <div>
            <!-- start_circle -->

              <div class="leaderboard_rank_box winners_upd_monthly" v-if="monthlyWin.length > 0">

                <h1>{{ getTranslations.visitor_visitor_winner_monthly }}</h1>
                <div v-for="(winner, index) in monthlyWin" :key="index">
                  <div class="rank_row">
                    <img :src="winner.userDTO.avatar">
                    <div class="upd_prize_col">
                      <h2>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }} {{ winner.userDTO.msisdn }}</h2>
                      <p>{{ winner.prizeDTO.headline }}</p>
                    </div>
                    <div class="vertical_line_rank"></div>
                    <div class="rank_points">
                      <div class="rank_col">
                        <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                        <label>{{ normalizeDate(winner.localDateTime) }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="rank_border"></div>
                </div>
                <div class="load_more_btn rank" v-if="moreWinnersMButton">
                  <button  class="load-more btn2 btn2--std btn2--small" @click="displayMore('MONTHLY')" :disabled="loading.MONTHLY">···</button>
                </div>
                <div class="upd_prize_bottom">
                  <p>{{ getTranslations.visitor_visitor_winner_the }} <span>{{ getTranslations.visitor_visitor_winner_next }}</span> {{ getTranslations.visitor_visitor_winner_announced }} <span>{{ getTranslations.visitor_visitor_winner_next_date_monthly }}</span></p>
                </div>
                <div class="last_upt">
                  <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                </div>
              </div>
              <div v-else class="winners_upd_grand">
                <h1>{{ getTranslations.visitor_visitor_winner_monthly }}</h1>
                <p>{{ getTranslations.visitor_visitor_winner_yet }}<span>{{ getTranslations.visitor_visitor_winner_next }}</span> {{ getTranslations.visitor_visitor_winner_announced }} <span>{{ getTranslations.visitor_visitor_winner_next_date_monthly }}</span></p>

                <div class="last_upt">
                  <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                </div>
              </div>
              <div class="leaderboard_rank_box winners_upd_instant" v-if="instantWin.length > 0">
                <h1>{{ getTranslations.visitor_visitor_winner_instant }}</h1>
                <div v-for="(winner, index) in instantWin" :key="index">
                  <div class="rank_row" >
                    <img :src="winner.userDTO.avatar">
                    <div class="upd_prize_col">
                      <h2>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }} {{ winner.userDTO.msisdn }}</h2>
                      <p>{{ winner.prizeDTO.headline }}</p>
                    </div>
                    <div class="vertical_line_rank"></div>
                    <div class="rank_points">
                      <div class="rank_col">
                        <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                        <label>{{ normalizeDate(winner.localDateTime) }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="rank_border"></div>
                </div>
                <div class="load_more_btn rank" v-if="moreWinnersIButton">
                  <button  class="load-more btn2 btn2--std btn2--small" @click="displayMore('WEEKLY')" :disabled="loading.WEEKLY">···</button>
                </div>
                <div class="upd_prize_bottom">
                  <p>{{ getTranslations.visitor_visitor_winner_the }} <span>{{ getTranslations.visitor_visitor_winner_next }}</span> {{ getTranslations.visitor_visitor_winner_announced }} <span>{{ getTranslations.visitor_visitor_winner_next_date_weekly }}</span></p>
                </div>
                <div class="last_upt">
                  <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                </div>
              </div>
              <div v-else class="winners_upd_grand">
                <h1>{{ getTranslations.visitor_visitor_winner_instant }}</h1>
                <p>{{ getTranslations.visitor_visitor_winner_yet }}<span>{{ getTranslations.visitor_visitor_winner_next }}</span> {{ getTranslations.visitor_visitor_winner_announced }} <span>{{ getTranslations.visitor_visitor_winner_next_date_weekly }}</span></p>

                <div class="last_upt">
                  <p>{{ getTranslations.visitor_visitor_winner_update }} <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Loading v-if="showLoadingModal"/>
</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import Loading from './home/modals/Loading.vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'winners',
  components: { Loading },
  data() {
    return {
      countTestimonials: 0,
      loading: {
        GRAND: false,
        MONTHLY: false,
        WEEKLY: false,
      },
      showLoadingModal: false
    };
  },
  watch: {
    fetchingInitialWinners: {
      handler (curValue) {
        if (!curValue) {
          this.showLoadingModal = false;
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    /* eslint-disable */
    console.log('==> inside component\'s beforeRouteLeave: Winners');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    this.storeVisitorWinners(this.getLocale);
    next();
    /* eslint-enable */
  },
  mounted () {
    if (this.fetchingInitialWinners) {
      this.showLoadingModal = true;
    }
  },
  created() {
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
      'loadMoreWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    displayMore(prizeType) {
      this.showLoadingModal = true;
      this.loading[prizeType] = true;
      this.loadMoreWinners({ userLanguage: this.getLocale, prizeType }).finally(() => {
        this.loading[prizeType] = false;
        this.showLoadingModal = false;
      });
    },
    normalizeDate(date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    ...mapState('profile', [
      'monthlyButton',
      'grandButton',
      'weeklyButton',
      'moreWinnersButton',
      'moreWinnersMButton',
      'moreWinnersIButton',
      'totalWinners',
      'fetchingInitialWinners',
      'instantWin',
      'grandWin',
      'monthlyWin',
      'allWinners',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationTestimonial',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Winners.vue